import * as React from "react";
import { FacetLink } from "./FacetLink.js";
const FacetWithTextNode = ({
  item,
  isActive,
  onPick,
  productType,
  children
}) => /* @__PURE__ */ React.createElement(
  FacetLink,
  {
    item,
    isActive,
    onPick,
    productType,
    accessibleName: void 0
  },
  children ? children : item.facetTerm
);
export {
  FacetWithTextNode
};
//# sourceMappingURL=FacetWithTextNode.js.map
